import { render, staticRenderFns } from "./SmallPie.vue?vue&type=template&id=1f44c17f&scoped=true&"
import script from "./SmallPie.vue?vue&type=script&lang=ts&"
export * from "./SmallPie.vue?vue&type=script&lang=ts&"
import style0 from "./SmallPie.vue?vue&type=style&index=0&id=1f44c17f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f44c17f",
  null
  
)

export default component.exports